var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { InputContainer, InputIcon, InputSpinner, InputWrapper } from './styles/input.styled';
// eslint-disable-next-line prefer-arrow-callback
export const Input = forwardRef(function InputWithForwardRef(_a, ref) {
    var { reference, required, disabled, valid, loading, variant = 'field-text', left, right, colorContext = 'on-light', color, onFocus, onBlur } = _a, props = __rest(_a, ["reference", "required", "disabled", "valid", "loading", "variant", "left", "right", "colorContext", "color", "onFocus", "onBlur"]);
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current, [inputRef]);
    const handleFocus = (event) => {
        var _a;
        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('focus');
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    const handleBlur = (event) => {
        var _a;
        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('focus');
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    return (React.createElement(InputWrapper, { "$colorContext": colorContext, "$color": color, "$invalid": valid === false, "$disabled": disabled === true, ref: wrapperRef, className: disabled ? 'disabled' : '' },
        left,
        React.createElement(InputContainer, Object.assign({ id: reference, required: required, disabled: disabled, "aria-required": required, "aria-disabled": disabled }, (valid === false && { 'aria-invalid': true }), { "data-hj-suppress": true, inputRef: ref, variant: variant, onFocus: handleFocus, onBlur: handleBlur }, props)),
        loading && React.createElement(InputSpinner, null),
        !loading && right,
        !loading && !right && (valid === false || color === 'error') && (React.createElement(InputIcon, { "$color": "error", "$disabled": disabled === true, variant: "error" })),
        !loading && !right && color === 'success' && (React.createElement(InputIcon, { "$color": "success", "$disabled": disabled === true, variant: "check-usp" }))));
});
//# sourceMappingURL=Input.js.map